// extracted by mini-css-extract-plugin
export default {"button":"ButtonSearch_button__em24C"};